import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ClaimTypeFilters from "../components/ClaimTypeFilters";
import Header from "../../../components/dms_common/Header";
import "./CreateClaimIndex.css";
import { useEffect, useCallback } from "react";
import {
  setSelectedClaimSubType,
  setSelectedClaimType,
  setSearchText
} from "../../../stateManagement/actions/claims";
import { getLastNPathSegments, determineClaimTypes } from "../utils/utils";
import emptyPageImageSrc from "../../../assets/image/png/emptyPage.png";
import EmptyPage from "../components/SelectClaimType";
import Search from "../../../components/dms_common/Search";
import ComingSoon from '../../../components/comingSoon/ComingSoon';
import { logAnalyticsEvent } from "../../../../src/firebase";

const CreateClaimIndex: React.FC = () => {
  const { selectedClaimType, selectedClaimSubType, searchText } = useSelector(
    (state: any) => state.claims
  );
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {claimTypes, claimSubTypes, activeDmsFeatures} = ConfigDictionary;
  const hasClaimsFeature = activeDmsFeatures && activeDmsFeatures.includes("claims");
  const dispatch = useDispatch();
  const distributorId = JSON.parse(localStorage.authContext).user.loginId;

  useEffect(() => {
    const [path] = getLastNPathSegments(window.location.href, 1);

    const { claimType, subClaimType } = determineClaimTypes(path, claimTypes, claimSubTypes);
    if (claimType) {
      dispatch(setSelectedClaimType(claimType));
      dispatch(setSelectedClaimSubType(subClaimType));
    }
  }, [window.location.href]);

  useEffect(() => {
    return () => {
      if (!window.location.pathname.includes("/dashboard/claims/create")) {
        dispatch(setSelectedClaimType(""));
        dispatch(setSelectedClaimSubType(""));
      }
    };
  }, []);  

  useEffect(() => {
    const [path] = getLastNPathSegments(window.location.href, 1);

    if (path === "create") {
      dispatch(setSelectedClaimType(""));
      dispatch(setSelectedClaimSubType(""));
    }
    logAnalyticsEvent("create_claim_clicked", {
      distributor_id: distributorId
    });
  }, []);

  const handleSearchValueChange = useCallback((newValue: string) => {
    dispatch(setSearchText(newValue));
  }, [dispatch]);

  const renderHeader = () => {
    if (selectedClaimType === claimTypes[0] && selectedClaimSubType === claimSubTypes[0]) {
      return `Review Approved ${selectedClaimSubType}`
    }
    else if (selectedClaimType === claimTypes[0] && selectedClaimSubType === claimSubTypes[1]) {
      return `${selectedClaimSubType} Details`
    }
    else if (selectedClaimType === claimTypes[1] && (selectedClaimSubType === claimSubTypes[2] || selectedClaimSubType === claimSubTypes[3])) {
      return "Review Discounts and Promotions";
    }
    return "";
  };

  if (!hasClaimsFeature) {
    return <ComingSoon />;
  }

  return (
    <div className="create-claim-root">
      <header className="top-heading">
        <Header title={"Create New Claim"} />
        {(selectedClaimSubType === claimSubTypes[2] || selectedClaimSubType === claimSubTypes[3]) ? (<div style={{ width: "280px" }}>
        <Search searchFunction={handleSearchValueChange} value={searchText}/>
      </div>) : (<></>)}
      </header>

      <ClaimTypeFilters />

      {renderHeader() && <Header title={renderHeader()} />}

        {(!selectedClaimType || !selectedClaimSubType) && <EmptyPage
          height={87}
          text={"Select Claim Type To Create/See New Claims"}
          imgSrc={emptyPageImageSrc}
      />}
      
      <div className="outlet-container">
      <Outlet />
      </div>
    </div>
  );
};

export default CreateClaimIndex;
